import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { PenLine } from 'lucide-react';

function UpdateAttributeNode({ data, selected }: NodeProps) {
  const config = (data.config as Record<string, unknown>) ?? {};
  const key = (config.key as string) ?? '';
  const value = (config.value as string) ?? '';

  return (
    <div
      className={`w-52 rounded-xl bg-white shadow-sm border border-zinc-200 border-l-4 border-l-sky-500 ${
        selected ? 'ring-2 ring-sky-500' : ''
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-sky-500" />
      <div className="flex items-center gap-2 px-3 py-2 border-b border-zinc-100">
        <PenLine size={14} className="text-sky-500 shrink-0" />
        <span className="text-xs font-semibold text-zinc-700 uppercase tracking-wide">
          Update Attribute
        </span>
      </div>
      <div className="px-3 py-2 space-y-0.5">
        {key ? (
          <>
            <p className="text-xs text-zinc-500">Attribute</p>
            <p className="text-xs text-zinc-800 font-medium truncate">{key}</p>
            {value !== '' && (
              <>
                <p className="text-xs text-zinc-500 mt-1">Value</p>
                <p className="text-xs text-zinc-700 truncate">{value}</p>
              </>
            )}
          </>
        ) : (
          <p className="text-xs italic text-zinc-400">Not configured</p>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-sky-500" />
    </div>
  );
}

export default memo(UpdateAttributeNode);
